import React from "react";
import HelmetComponent from "./HelmetComponent";
import HelpModal from "../components/commenComponents/HelpModal";

function Help(props) {
  return (
    <div className=" min-h-screen">
      <HelmetComponent
        title="Akerayu | Help Center: Find Answers to Your Questions"
        description="Akerayu: Your questions, answered. Our FAQs cover everything you need to know about using Akerayu."
        imageUrl="https://akerayu.com/emailImages/logo.png"
        pageUrl="https://akerayu.com/help"
        type="website"
        robots="index, follow"
      />

      <div className="w-6/12 max-sm:w-11/12 max-md:w-10/12 max-lg:w-8/12 m-auto">

          <HelpModal />

      </div>
    </div>
  );
}

export default Help;
